const stringToUndefined = (value?: string) => {
	if (typeof value === "string") {
		return value.trim().length ? value : undefined;
	}
	return undefined;
};

export default stringToUndefined;
